import { styled } from "@linaria/react"

// 18px;

export const IconButton = styled.button<{
  variant?: "text" | "outlined"
  size?: "small" | "medium" | "large"
  color?: "accent" | "secondary"
}>`
  outline: none;
  border: none;
  background-color: transparent;

  display: flex;

  border-radius: calc(var(--mui-shape-borderRadius) / 2);
  &:not(:disabled) {
    cursor: pointer;
  }
  transition: all 0.17s ease-in-out;

  transform: scale(1);
  &:not(:disabled):active {
    transform: scale(0.92);
  }
  // margin-bottom: 10px;

  padding: ${(props) =>
    props.size === "large"
      ? "calc(var(--spacing) / 2)"
      : props.size === "medium"
        ? "calc(var(--spacing) / 2)"
        : "calc(var(--spacing) / 4)"};

  svg {
    height: ${(props) =>
      props.size === "large" ? "22px" : props.size === "medium" ? "18px" : "14px"};
    width: ${(props) =>
      props.size === "large" ? "22px" : props.size === "medium" ? "18px" : "14px"};
    color: ${(props) =>
      props.color === "accent" ? "rgb(var(--theme-color))" : "var(--mui-palette-text-secondary)"};
  }

  border: ${(props) =>
    props.variant === "outlined" ? "1px solid var(--mui-palette-borderPrimary)" : "none"};
`
